export const menuItems = [
 {
  title: "Home",
  link: "#home"
 },
 {
  title: "Projects",
  link: "#projects"
 },
 {
  title: "Contact",
  link: "#contact"
 }
];